import type { TypePolicy } from '@apollo/client';
import { cursorPaginationFieldPolicy } from '../../../../utils/policies/cursorPaginationFieldPolicy';

export const typePolicies: Record<string, TypePolicy> = {
  ShareList: {
    fields: {
      members: cursorPaginationFieldPolicy([
        'page',
        ['first'],
        'filter',
        ['query'],
      ]),
    },
  },
};
